<div class="{{ wrapperClass }}">
  <ng-template #dynamicComponentContainer></ng-template>
</div>
